const getMarketplaceDomain = () => {
  if (process.env.REACT_APP_ENVIRONMENT !== 'development') {
    return 'services.clientvenue.com'
  }
  return 'gravity.clientvenue.com'
}

export default getMarketplaceDomain
